import { createEntityAdapter, EntityState } from '@ngrx/entity';

import { ObjectCardKind, ObjectCardType } from '@common/components/object-card';

import { MonitoringItem } from '../../app/portal/pages/monitoring-page/monitoring.types';

/** Загруженные данные карточек: по типу карточки, внутри — по id объекта */
export type ObjectCardsByKind = Record<ObjectCardKind, Record<number, ObjectCardType>>;

export const monitoringAdapter = createEntityAdapter<MonitoringItem>({
  selectId: (item) => item.id as number,
});

export interface MonitoringState extends EntityState<MonitoringItem> {
  loading: boolean;
  error?: string;
  visibleIds: number[];
  maxRt: number | null;
  openedObjectCardOnMapId: number | null;
  /**
   * Данные карточек объектов. Одна и та же карточка (тип + id) может быть открыта в нескольких
   * местах сразу (попап на карте и попап по ховеру в списке), они читают один слот.
   */
  objectCards: ObjectCardsByKind;
  /** Карточки, запрос данных которых сейчас в полёте: по типу, внутри — id объектов */
  objectCardsLoading: Record<ObjectCardKind, number[]>;
  /** Объекты, у которых раскрыта фиксированная карточка в списке мониторинга */
  fixedObjectCardIds: number[];
  trackedObjectOnMapId: number | null;
  searchText?: string;
  sortBy?: keyof MonitoringItem;
  sortDirection?: 'asc' | 'desc';
}

export const initialMonitoringState: MonitoringState = monitoringAdapter.getInitialState({
  loading: false,
  error: undefined,
  visibleIds: [],
  maxRt: null,
  openedObjectCardOnMapId: null,
  objectCards: { floating: {}, fixed: {} },
  objectCardsLoading: { floating: [], fixed: [] },
  fixedObjectCardIds: [],
  trackedObjectOnMapId: null,
  searchText: '',
  sortBy: 'name',
  sortDirection: 'asc',
});
